namespace TabAurous.Inventory {
    export namespace CertificationReturnTaxService {
        export const baseUrl = 'CertificationReturn/CertificationReturnTax';

        export declare function Create(request: Serenity.SaveRequest<CertificationReturnTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CertificationReturnTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CertificationReturnTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CertificationReturnTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CertificationReturn/CertificationReturnTax/Create",
            Update = "CertificationReturn/CertificationReturnTax/Update",
            Delete = "CertificationReturn/CertificationReturnTax/Delete",
            Retrieve = "CertificationReturn/CertificationReturnTax/Retrieve",
            List = "CertificationReturn/CertificationReturnTax/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CertificationReturnTaxService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
